import {Fragment} from "preact";
import FirstStep from "./FirstStep";
import {useInitialSteps} from "./useInitialSteps";
import SecondStep from "./SecondStep";
import s from "./initialSteps.module.css";
import {firstStepBackground} from "../../../../assets";

/**
 * A wrapper for both the first and the second steps of the form,
 * as they are sort of "merged" into the same screen.
 * */
const InitialSteps = (props) => {
    // Destructured props
    const {
        handleStepChange,
        currentStep,
        surveyData,
        handlePayloadUpdate
    } = props;

    // Component logic data
    const componentProps = useInitialSteps({
        surveyData,
        handleStepChange,
        handlePayloadUpdate
    });

    // Destructured component logic data
    const {
        formValues,
        handleChange,
        handleSubmit
    } = componentProps;

    return (
        <Fragment>
            <form
                onSubmit={(e) => handleSubmit(e)}
                className={`${s.root} ${currentStep > 2 ? s.hideContent : ""}`}
            >
                <div className={"flex flex-row justify-center w-full md:w-max shrink-0"}>
                    <img
                        src={firstStepBackground}
                        alt="Background image"
                    />
                </div>
                <div className={"flex flex-col gap-y-5"}>
                    <FirstStep
                        formValues={formValues}
                        handleChange={handleChange}
                        surveyData={surveyData}
                    />
                    <div className={`overflow-hidden transition-all duration-700 ${currentStep < 2 ? "max-h-0 opacity-0" : "max-h-[500px] opacity-100"}`}>
                        <SecondStep
                            formValues={formValues}
                            handleChange={handleChange}
                            surveyData={surveyData}
                        />
                    </div>
                </div>
            </form>
        </Fragment>
    )
}

export default InitialSteps;
